<template>
  <ReportFilterSelect
    :model-value="modelValue"
    label="Merchant"
    :options="merchantOptions"
    @update:model-value="
      (value) => emit('update:modelValue', value)
    "
  />
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue?: string | null
}>()

const emit = defineEmits<{
  (
    event: "update:modelValue",
    value: typeof props.modelValue
  ): void
}>()

const { data: merchantResp } = useMerchantGroupMerchants()

const merchantOptions = computed(
  () =>
    merchantResp.value?.merchants.map((m) => ({
      value: m.schemaName,
      label: m.merchantName,
    })) ?? []
)
</script>
